/* eslint-disable react/require-default-props */
import BulletinContent from 'components/organisms/bulletin_content';
import BulletinSearch from 'components/organisms/bulletin_search';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IaChatMessageTypes } from 'store/modules/bulletins_store/types';

interface BulletinDataProps {
  matchMode?: boolean;
}

const BulletinData: React.FC<BulletinDataProps> = ({ matchMode = false }) => {
  const { id = '' } = useParams<{ id?: string }>();
  const [selectedTab, setSelectedTab] = useState<'licitacoes' | 'acompanhamentos'>('licitacoes');
  const [searchesRefreshKey, setSearchesRefreshKey] = useState(0);
  const editFilterRef = useRef<
    | ((name: string, ai: boolean, chatHistory?: IaChatMessageTypes[], searchId?: number) => void)
    | null
  >(null);
  const deleteFilterRef = useRef<(() => void) | null>(null);
  const saveAppliedFilterRef = useRef<((chatHistory?: IaChatMessageTypes[]) => void) | null>(null);

  useEffect(() => {
    document.title = 'Boletim - ConLicitação';
  }, []);

  const handleEditFilter = useCallback(
    (name: string, ai: boolean, chatHistory?: IaChatMessageTypes[], searchId?: number) => {
      editFilterRef.current?.(name, ai, chatHistory, searchId);
    },
    [],
  );

  const handleDeleteFilter = useCallback(() => {
    deleteFilterRef.current?.();
  }, []);

  const handleSaveAppliedFilter = useCallback((chatHistory?: IaChatMessageTypes[]) => {
    saveAppliedFilterRef.current?.(chatHistory);
  }, []);

  return (
    <div className="page-container">
      <div className="container-fluid">
        <div className="row">
          <BulletinSearch
            bulletinId={id}
            selected={selectedTab}
            onChangeSelected={setSelectedTab}
            registerEditFilter={(fn) => {
              editFilterRef.current = fn;
            }}
            registerDeleteFilter={(fn: () => void) => {
              deleteFilterRef.current = fn;
            }}
            registerSaveAppliedFilter={(fn) => {
              saveAppliedFilterRef.current = fn;
            }}
            onSearchesChanged={() => setSearchesRefreshKey((k) => k + 1)}
            matchMode={matchMode}
          />
          <div className="col-md-9 ml-auto">
            <BulletinContent
              externalTab={selectedTab}
              onEditFilter={handleEditFilter}
              onDeleteFilter={handleDeleteFilter}
              onSaveAppliedFilter={handleSaveAppliedFilter}
              searchesRefreshKey={searchesRefreshKey}
              matchMode={matchMode}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulletinData;
